// extracted by mini-css-extract-plugin
export default {"white":"#fff","container":"YuShw","spinner":"syjKB","header":"CJBNn","heading":"YFju0","searchIcon":"vJxpD"};